import "./homeSeparator.css";

function HomeSeparator({ w = "80%", t = "10px", b = "10px" }) {
  return (
    <div className="home-separator-contenair">
      <div
        className="home-separator"
        style={{ width: w, marginTop: t, marginBottom: b }}
      ></div>
    </div>
  );
}

export default HomeSeparator;
